import React from "react";
import PropTypes from "prop-types";
import VariantDBDetails from "../../../../../models/VariantDBDetails";
import ReviewStars from "../../../components/ReviewStars";
import splitClinvarMainData from "../../../helpers/splitClinvarMainData";
import VariantDBDetailsFrequency from "../../../../../models/VariantDBDetailsFrequency";
import VariantLink from "../../../components/TooltipActions/VariantLink";

function VariantTitle({ item, actions }) {
  if (!item) return null;
  const { mainData, reviewStars } = splitClinvarMainData(
    item?.mainData || "",
    item?.reviewStars,
    item?.db || {}
  );

  return (
    <>
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">
          <VariantLink variant={item.variant} />
        </div>
        {actions}
      </div>

      {item?.db?.name ? (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Source</div>
          <div>{item?.db?.name}</div>
          <div className="tw-w-2" />
          <ReviewStars stars={reviewStars} />
        </div>
      ) : null}

      {mainData ? (
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Source Data</div>
          <div>{mainData}</div>
        </div>
      ) : null}
    </>
  );
}

VariantTitle.propTypes = {
  actions: PropTypes.node,
  item: PropTypes.oneOfType([
    PropTypes.instanceOf(VariantDBDetailsFrequency),
    PropTypes.instanceOf(VariantDBDetails),
  ]).isRequired,
};
VariantTitle.defaultProps = {
  actions: null,
};
export default VariantTitle;
